import fvSubassembly from "../fvSubassembly"
export default class fvCakeObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        // 创建图元
        // 添加path路径
        this.cakeDom = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        system.appendChild(this.cakeDom);
        if(this.renderType==4||this.renderType==5||this.renderType==6){
            this.caketDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            system.insertBefore(this.caketDefs, this.cakeDom);
        }
        this.createSucss(this.cakeDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineCakeDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.lineCakeDom);
            }
        }
        // 创建样式
        this.parent = parent;
        this.createStyle();
    }
    createStyle() {
        this.setPosition();
        this.cakeDom.setAttribute("stroke-width", this.borderWidth);
        this.setBorderColor();
        this.setFillColor();
        // 线型
        super.chooseRenderType(this.lineType, this.cakeDom);
        
        this.Render();
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineCakeDom.innerHTML = "";
                this.drawStereo(this.lineCakeDom,this.cakeDom);
            }
        }
		
    }
    //设置路径
    setPosition() {
        this.cakeDom.setAttribute('d', `M ${(this.cx - this.parent.parentX) + this.width}, ${this.cy - this.parent.parentY} A ${this.width}, ${this.height} 0 0 1 ${this.cx - this.parent.parentX}, ${(this.cy - this.parent.parentY) + this.height} z`);
    }
    // 设置填充颜色
    setFillColor() {
        let rgbArray = this.color.colorRgb(this.opacity / 255);
        this.cakeDom.style.fill = rgbArray;
    }
    // 设置边框颜色
    setBorderColor() {
        this.cakeDom.setAttribute("stroke", this.borderColor);
    }
    // 显示隐藏
    isShow(value) {
        this.fcHide = value;
        value ? this.cakeDom.style.display = 'block' : this.cakeDom.style.display = 'none';
    }
    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.cakeDom);
        this.cakeDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'})`;
    }
     //风格渲染
     Render() {
        if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
        switch (this.renderType) {
            // case 1:  //模式1
            // case 2:  //模式2
            // case 3:  //模式3
            case 4:  //svg线性渐变效果
                this.linearGradient(this.uuid(), this.renderConfig, this.cakeDom,this.cx - this.parent.parentX, this.cy - this.parent.parentY,this.caketDefs);
                break;
            case 5:  //svg路径渐变效果
                this.cakeDom.style.width=this.width;
                this.cakeDom.style.height=this.height;
                this.radialGradient(this.uuid(), this.renderConfig, this.cakeDom, this.cx - this.parent.parentX, this.cy - this.parent.parentY,this.caketDefs);
                break;
            case 6:  //svg纹理渐变效果
                this.pattern(this.uuid(), this.cakeDom,this.caketDefs);
                break;
            default:
                break;
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvCakeObj.js